export const passwordChange = (value, questionId) => ({
  type: 'PASSWORD_CHANGE',
  index: 0,
  questionId,
  value,
});

export const passwordBlur = questionId => ({
  type: 'PASSWORD_BLUR',
  questionId,
});
